module.exports = __webpack_public_path__ + "static/media/Rubik-Black.5f58705d.ttf";